var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 874,
    height: 347,
    viewBox: "0 0 874 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_859_6366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.005 319.91C515.547 319.91 576.785 258.671 576.785 183.13C576.785 107.588 515.547 46.35 440.005 46.35C364.464 46.35 303.225 107.588 303.225 183.13C303.225 258.671 364.464 319.91 440.005 319.91Z",
    fill: "#1F3362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.345 277.67H14.3447L0.344727 217.85L158.855 29.2H244.445V214.35H283.305V277.67H244.445V337.06H162.345V277.67ZM162.345 214.79V127.02L89.4247 214.79H162.345Z",
    fill: "url(#paint0_linear_859_6366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.715 277.67H604.715L590.715 217.85L749.215 29.2H834.805V214.35H873.675V277.67H834.805V337.06H752.715V277.67ZM752.715 214.79V127.02L679.785 214.79H752.715Z",
    fill: "url(#paint1_linear_859_6366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.455 119.79L448.025 119.83L395.525 119.89L329.345 330.13H448.025H550.705L483.455 119.79Z",
    fill: "url(#paint2_linear_859_6366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.025 166.11C478.547 166.11 509.775 134.882 509.775 96.36C509.775 57.8381 478.547 26.61 440.025 26.61C401.503 26.61 370.275 57.8381 370.275 96.36C370.275 134.882 401.503 166.11 440.025 166.11Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.635 96.36C509.635 96.36 486.455 110.66 439.495 110.66C392.535 110.66 369.945 96.36 369.945 96.36C369.945 96.36 289.325 119.58 289.325 135.65C289.325 151.72 379.735 166.13 439.495 166.13C499.255 166.13 590.005 151.72 590.005 135.65C590.005 119.58 509.635 96.36 509.635 96.36Z",
    fill: "#3E64C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.675 97.25C366.675 97.25 374.595 138.86 425.535 138.86C476.475 138.86 511.735 99.77 511.735 99.77C511.735 99.77 489.655 106.66 439.495 106.66C389.335 106.66 366.675 97.25 366.675 97.25Z",
    fill: "#3759AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.505 27.13V7.13",
    stroke: "#3E64C3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.895 14.78C441.976 14.78 445.285 11.4714 445.285 7.39C445.285 3.30862 441.976 0 437.895 0C433.813 0 430.505 3.30862 430.505 7.39C430.505 11.4714 433.813 14.78 437.895 14.78Z",
    fill: "#D15B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.025 346.25C501.152 346.25 550.705 338.97 550.705 329.99C550.705 321.01 501.152 313.73 440.025 313.73C378.898 313.73 329.345 321.01 329.345 329.99C329.345 338.97 378.898 346.25 440.025 346.25Z",
    fill: "url(#paint3_linear_859_6366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.105 243.86L442.745 276.43C442.45 276.653 442.115 276.816 441.757 276.909C441.399 277.002 441.027 277.023 440.661 276.972C440.295 276.921 439.943 276.798 439.624 276.611C439.306 276.424 439.027 276.175 438.805 275.88L402.065 226.98C401.618 226.383 401.427 225.633 401.531 224.894C401.636 224.156 402.03 223.489 402.625 223.04L438.265 196.27L456.175 199.34L486.665 239.92C487.112 240.517 487.304 241.267 487.199 242.006C487.094 242.744 486.7 243.411 486.105 243.86Z",
    fill: "#3E64C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.265 196.27L456.175 199.34L448.385 205.73C448.143 205.928 447.864 206.074 447.564 206.161C447.264 206.248 446.95 206.274 446.64 206.237C446.33 206.199 446.031 206.1 445.76 205.944C445.489 205.788 445.253 205.579 445.065 205.33L438.265 196.27Z",
    fill: "#7188C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.455 236.03C430.443 236.03 432.055 234.418 432.055 232.43C432.055 230.442 430.443 228.83 428.455 228.83C426.467 228.83 424.855 230.442 424.855 232.43C424.855 234.418 426.467 236.03 428.455 236.03Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.085 221.29C450.073 221.29 451.685 219.678 451.685 217.69C451.685 215.702 450.073 214.09 448.085 214.09C446.097 214.09 444.485 215.702 444.485 217.69C444.485 219.678 446.097 221.29 448.085 221.29Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.508 244.218C454.296 242.874 453.401 238.664 450.508 234.814C447.615 230.963 443.82 228.931 442.032 230.275C440.244 231.619 441.139 235.829 444.032 239.679C446.925 243.529 450.72 245.561 452.508 244.218Z",
    fill: "#1F3262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.155 216.71L503.625 218.52C503.449 218.537 503.272 218.496 503.122 218.403C502.972 218.309 502.858 218.169 502.796 218.003C502.734 217.837 502.729 217.656 502.781 217.487C502.834 217.319 502.94 217.172 503.085 217.07C506.155 215 510.555 210.94 513.635 203.5C516.715 196.06 516.135 191.42 515.745 189.91C515.704 189.741 515.72 189.563 515.79 189.404C515.861 189.245 515.982 189.113 516.135 189.03L531.135 180.86C531.247 180.797 531.373 180.762 531.502 180.759C531.63 180.755 531.758 180.783 531.873 180.841C531.988 180.898 532.088 180.982 532.163 181.087C532.239 181.191 532.287 181.312 532.305 181.44C533.082 187.607 532.291 193.87 530.005 199.65C527.704 205.642 524.577 211.283 520.715 216.41C520.648 216.496 520.563 216.568 520.467 216.62C520.37 216.671 520.264 216.702 520.155 216.71Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.535 278.22C331.605 283.02 325.915 300.47 339.985 311.67C340.365 311.975 340.822 312.168 341.306 312.23C341.789 312.292 342.28 312.219 342.725 312.02L363.725 302.47C364.086 302.307 364.406 302.063 364.66 301.759C364.914 301.454 365.096 301.096 365.192 300.712C365.288 300.327 365.296 299.926 365.215 299.537C365.134 299.149 364.967 298.784 364.725 298.47C361.405 294.11 355.625 284.8 357.965 275.2C358.076 274.762 358.073 274.303 357.956 273.866C357.838 273.43 357.61 273.031 357.293 272.708C356.977 272.386 356.582 272.15 356.148 272.024C355.714 271.898 355.255 271.887 354.815 271.99L335.375 276.64C334.964 276.737 334.583 276.931 334.263 277.206C333.942 277.481 333.693 277.829 333.535 278.22Z",
    fill: "#8BA2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.395 149.78C384.557 149.78 392.795 141.542 392.795 131.38C392.795 121.218 384.557 112.98 374.395 112.98C364.233 112.98 355.995 121.218 355.995 131.38C355.995 141.542 364.233 149.78 374.395 149.78Z",
    fill: "#2F4B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.655 149.78C515.817 149.78 524.055 141.542 524.055 131.38C524.055 121.218 515.817 112.98 505.655 112.98C495.493 112.98 487.255 121.218 487.255 131.38C487.255 141.542 495.493 149.78 505.655 149.78Z",
    fill: "#2F4B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.655 145.51C513.459 145.51 519.785 139.184 519.785 131.38C519.785 123.576 513.459 117.25 505.655 117.25C497.851 117.25 491.525 123.576 491.525 131.38C491.525 139.184 497.851 145.51 505.655 145.51Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.885 157.25C450.047 157.25 458.285 149.012 458.285 138.85C458.285 128.688 450.047 120.45 439.885 120.45C429.723 120.45 421.485 128.688 421.485 138.85C421.485 149.012 429.723 157.25 439.885 157.25Z",
    fill: "#2F4B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.505 289.13V305.13",
    stroke: "#3E64C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.505 283.13V292.13",
    stroke: "#3E64C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.505 301.13V305.13",
    stroke: "#3E64C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.505 282.13V291.13",
    stroke: "#3E64C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.505 297.13V302.13",
    stroke: "#3E64C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.115 66.46C475.102 66.46 479.955 61.6068 479.955 55.62C479.955 49.6333 475.102 44.78 469.115 44.78C463.128 44.78 458.275 49.6333 458.275 55.62C458.275 61.6068 463.128 66.46 469.115 66.46Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.115 81.95C493.059 81.95 495.445 79.5637 495.445 76.62C495.445 73.6764 493.059 71.29 490.115 71.29C487.171 71.29 484.785 73.6764 484.785 76.62C484.785 79.5637 487.171 81.95 490.115 81.95Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.505 77.77C427.505 77.77 423.875 82.85 423.875 93.01C423.875 103.17 433.875 110.31 437.505 110.31C441.135 110.31 451.135 103.18 451.135 93.01C451.135 82.84 447.475 77.77 437.505 77.77Z",
    fill: "#94A8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.005 96.2C440.005 96.2 439.825 92.04 442.525 90.2C445.225 88.36 449.205 89.67 449.205 89.67C449.205 89.67 449.305 94.9499 446.325 96.2099C442.525 97.7799 440.005 96.2 440.005 96.2Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.165 96.2C435.165 96.2 435.345 92.04 432.645 90.2C429.945 88.36 425.965 89.67 425.965 89.67C425.965 89.67 425.865 94.9499 428.845 96.2099C432.645 97.7799 435.165 96.2 435.165 96.2Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.495 114.66C391.925 114.66 368.775 100.35 367.815 99.7399C367.352 99.4686 366.949 99.107 366.629 98.6765C366.309 98.2461 366.078 97.7558 365.952 97.2346C365.825 96.7134 365.804 96.172 365.891 95.6427C365.978 95.1134 366.17 94.6069 366.457 94.1534C366.743 93.6999 367.118 93.3087 367.558 93.0029C367.999 92.6972 368.497 92.4832 369.022 92.3738C369.547 92.2643 370.089 92.2615 370.615 92.3657C371.141 92.4698 371.641 92.6787 372.085 92.98C372.295 93.11 394.485 106.66 439.495 106.66C484.505 106.66 507.325 93.09 507.495 92.95C508.399 92.3943 509.487 92.2207 510.52 92.4673C511.552 92.7139 512.444 93.3606 513 94.265C513.555 95.1693 513.729 96.2574 513.482 97.2898C513.236 98.3222 512.589 99.2143 511.685 99.77C510.755 100.38 487.005 114.66 439.495 114.66Z",
    fill: "#6583CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.655 117.26C504.986 117.269 504.317 117.323 503.655 117.42L492.165 135.48C493.079 138.471 494.957 141.077 497.505 142.89L512.615 119.13C510.498 117.91 508.099 117.265 505.655 117.26Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.575 121.33L500.765 144.63C502.331 145.209 503.986 145.507 505.655 145.51C505.865 145.51 506.065 145.51 506.265 145.51L518.695 125.97C517.974 124.231 516.914 122.654 515.575 121.33Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.655 152.98C447.459 152.98 453.785 146.654 453.785 138.85C453.785 131.046 447.459 124.72 439.655 124.72C431.851 124.72 425.525 131.046 425.525 138.85C425.525 146.654 431.851 152.98 439.655 152.98Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.655 124.73C438.986 124.739 438.317 124.793 437.655 124.89L426.165 142.95C427.079 145.941 428.956 148.547 431.505 150.36L446.645 126.57C444.516 125.355 442.106 124.721 439.655 124.73Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.575 128.8L434.765 152.13C436.331 152.709 437.986 153.007 439.655 153.01C439.865 153.01 440.065 153.01 440.265 153.01L452.695 133.47C451.978 131.72 450.917 130.132 449.575 128.8Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.395 145.51C382.199 145.51 388.525 139.184 388.525 131.38C388.525 123.576 382.199 117.25 374.395 117.25C366.591 117.25 360.265 123.576 360.265 131.38C360.265 139.184 366.591 145.51 374.395 145.51Z",
    fill: "#BFCBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.395 117.26C373.725 117.269 373.057 117.322 372.395 117.42L360.905 135.48C361.815 138.473 363.693 141.08 366.245 142.89L381.345 119.13C379.231 117.912 376.835 117.267 374.395 117.26Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.315 121.33L369.505 144.63C371.07 145.209 372.726 145.507 374.395 145.51C374.605 145.51 374.805 145.51 375.005 145.51L387.435 125.97C386.714 124.231 385.653 122.654 384.315 121.33Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.005 26.61C428.225 26.5959 416.635 29.5795 406.325 35.28C407.225 34.92 439.185 22.34 471.145 40.18C503.105 58.02 509.425 91.18 509.635 92.31C508.604 74.5419 500.819 57.8402 487.874 45.6257C474.929 33.4112 457.803 26.6082 440.005 26.61Z",
    fill: "#D9E0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.005 135.65C590.005 121.44 527.155 101.65 512.655 97.25C512.655 97.25 575.775 121.15 577.285 133.3C578.795 145.45 545.005 155.13 544.935 155.13L567.935 149.45C581.445 145.21 590.005 140.57 590.005 135.65Z",
    fill: "#6583CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.325 135.65C289.325 121.44 352.175 101.65 366.675 97.25C366.675 97.25 303.555 121.13 302.005 133.3C300.455 145.47 334.325 155.13 334.355 155.13L311.355 149.45C297.845 145.21 289.325 140.57 289.325 135.65Z",
    fill: "#6583CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_859_6366",
    x1: 141.825,
    y1: 29.2,
    x2: 141.825,
    y2: 337.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D4DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D0D7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_859_6366",
    x1: 732.185,
    y1: 29.2,
    x2: 732.185,
    y2: 337.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D4DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D0D7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_859_6366",
    x1: 440.025,
    y1: 119.79,
    x2: 440.025,
    y2: 330.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F7F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E1E6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D4DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_859_6366",
    x1: 440.025,
    y1: 313.73,
    x2: 440.025,
    y2: 346.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E6EAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE0EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_6366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 873.33,
    height: 346.25,
    fill: "white",
    transform: "translate(0.334961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.e41d4b517e96108416cc434fea5a67c6.svg";
export { ForwardRef as ReactComponent };